var _rect, _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOtherSetting(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 99,
    rx: 11.5,
    fill: "#F8FBFF",
    stroke: "#EBF1FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0366 28.2567L25.0686 33.6287C23.8718 35.0975 23.3006 37.7313 23.1646 38.8647L15.4806 39.2047C14.6102 41.4351 15.1179 47.886 15.4806 50.8327H23.1646C23.219 52.3015 24.5019 54.89 25.1366 56.0007L19.7646 61.6447C20.907 64.5279 25.5446 68.15 27.7206 69.6007L33.7046 64.4327C35.6086 65.6295 37.7619 66.2913 38.6006 66.4727L39.0086 74.3607L44.5846 74.9047C42.2998 71.9127 42.0459 65.1353 42.2046 62.1207C28.2238 59.0199 26.6326 47.138 27.5846 41.5847C29.5974 30.9767 38.6233 27.826 42.8846 27.5767C56.4302 27.0327 61.3126 37.3687 62.0606 42.6047C66.8478 41.7887 72.2153 43.67 74.3006 44.7127C74.627 43.8423 74.1646 40.8593 73.8926 39.4767L65.9366 38.9327C65.9366 38.1711 64.8033 35.17 64.2366 33.7647L69.3366 28.2567C68.1398 25.6999 63.4433 21.9327 61.2446 20.3687L55.6686 25.5367C55.0158 24.7207 51.8153 23.7007 50.2966 23.2927V15.5407C45.5638 14.5615 40.8446 15.1327 39.0766 15.5407L38.6006 23.2927C36.0982 24.0543 34.2033 25.106 33.5686 25.5367L27.9246 20.3687C23.6814 22.1639 20.8979 26.3753 20.0366 28.2567Z",
    fill: "url(#paint0_linear_199_6646)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3055 45.4736C32.8495 54.4496 40.1029 57.0563 43.6615 57.2376C46.3271 49.132 53.7029 44.8389 57.0576 43.7056C54.8272 32.88 46.0642 32.0323 41.9615 32.9616C33.5295 35.0832 32.0109 42.1869 32.3055 45.4736Z",
    fill: "url(#paint1_linear_199_6646)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.4793 57.4935L48.2153 53.8215C48.578 52.9602 50.0921 50.7207 53.2473 48.6535L56.9873 51.9175C57.8033 51.4869 59.6665 50.6119 60.5913 50.5575V45.5255C62.0646 45.1175 65.6641 44.5463 68.2753 45.5255L68.4793 50.5575C69.3406 50.8522 71.2265 51.5367 71.8793 51.9175L75.8233 48.5175C77.342 49.6282 80.4881 52.2439 80.9233 53.8215L77.5233 57.6295C77.9313 58.4229 78.7609 60.2135 78.8153 61.0295L84.1193 61.3015C84.346 63.1149 84.6361 67.1495 83.9833 68.7815H79.0193C78.7473 69.7109 78.0673 71.7327 77.5233 72.3855L80.8553 76.0575C80.334 77.2135 78.5433 79.8927 75.5513 81.3615L71.9473 78.0295C71.1313 78.3922 69.2817 79.1583 68.4113 79.3215L68.1393 84.4895C66.9833 84.8749 63.8961 85.4143 60.7953 84.4895L60.5913 79.3215C59.9793 79.1855 58.4561 78.7367 57.2593 78.0295L53.3833 81.3615C52.114 80.6362 49.2761 78.5599 48.0793 76.0575L51.4113 72.4535C50.9353 71.5695 50.0105 69.6247 50.1193 68.9175L45.0873 68.7135C44.6566 67.2629 44.0537 63.7359 45.0873 61.2335L50.1193 61.0295C50.2326 60.1682 50.6633 58.2551 51.4793 57.4935ZM64.5086 72.4568C68.7148 72.4568 72.1246 69.047 72.1246 64.8408C72.1246 60.6346 68.7148 57.2248 64.5086 57.2248C60.3024 57.2248 56.8926 60.6346 56.8926 64.8408C56.8926 69.047 60.3024 72.4568 64.5086 72.4568Z",
    fill: "#F8C532"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5 69C74.7 62.6 70.3333 59.1667 68 58C71.1667 59.5 75.2857 63 72.5 69.5C70.9079 73.215 67 73.5 64.5 72.5C67 73.0264 70.575 70.85 71.5 69Z",
    fill: "#E7AC04"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5 54C80.1 52 77.5 49.5 76 48.5L75 49.5L79.5 54L76 58L78.5 62L83 62.5L83.5 68L79 68.5H84C84.8 68.1 84.3333 63.8333 84 61.5L79 61L77.5 57.5L80.5 54Z",
    fill: "#E6AC04"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_199_6646",
    x1: 22,
    y1: 35.5,
    x2: 46.5,
    y2: 47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FAEF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B77E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_199_6646",
    x1: 34.5,
    y1: 40.0001,
    x2: 57,
    y2: 53.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2C6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6DCFB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherSetting);
export default __webpack_public_path__ + "static/media/other-setting.d07f7a934687c4224d46e1006994f15f.svg";
export { ForwardRef as ReactComponent };